import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import _ from 'lodash';
import BusinessActivityCreateModal from './BusinessActivityCreateModal';
import BusinessActivityUpdateModal from './BusinessActivityUpdateModal';
import * as c from '../constant';
import * as actions from '../actions';
import { ucwords } from '../helper';

function BusinessActivityList({
  businessId,
  getBusinessActivityList,
  businessActivityList,
  removeBusinessActivity,

  createBusinessActivity,
  updateBusinessActivity,

  pathName,
  type,
  activityList,
}) {
  const [viewForm, setViewForm] = useState(false);
  const [viewUpdateForm, setViewUpdateForm] = useState(false);
  const [formData, setFormData] = useState('');

  const checkIfForRenewal = pathName.indexOf('/bpls/applications/renewal') > -1;

  useEffect(() => {
    getBusinessActivityList(businessId, () => {
      setViewForm(false);
      setViewUpdateForm(false);
    });
  }, [businessId]);

  const handleAddBusinessActivity = e => {
    e.preventDefault();
    setViewForm(true);
    setViewUpdateForm(false);
  };

  const handleUpdateBusinessActivity = (id, data) => e => {
    e.preventDefault();
    setViewUpdateForm(true, setFormData(data));
    setViewForm(false);
  };

  const closeModal = () => {
    setViewForm(false);
  };

  const closeUpdateModal = () => {
    setViewUpdateForm(false);
  };

  const handleRemoveBusinessActivity = (id, data) => e => {
    e.preventDefault();

    ConfirmAlert(
      'Are you sure you want to remove this business activity?',
      () => {
        removeBusinessActivity(id, data.id, () => {
          getBusinessActivityList(id);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleOnCreate = data => e => {
    e.preventDefault();
    const details = _.omit(
      data,
      'business_nature_id',
      'business_line_id',
      'capital_amount',
      'gross_amount'
    );

    ConfirmAlert(
      'Are you sure you want to add this business activity?',
      () => {
        const args = {
          business_nature_id: _.get(data, 'business_nature_id'),
          business_line_id: _.get(data, 'business_line_id'),
          capital_amount: _.get(data, 'capital_amount'),
          gross_amount: _.get(data, 'gross_amount') || 0,
          details: { ...details },
        };
        createBusinessActivity(businessId, args, () => {
          getBusinessActivityList(businessId);
        });
        setViewForm(false);
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleOnUpdate = data => e => {
    e.preventDefault();
    const businessActivityId = _.get(formData, 'id');
    const details = _.omit(
      data,
      'business_nature_id',
      'business_line_id',
      'capital_amount',
      'gross_amount'
    );

    ConfirmAlert(
      'Are you sure you want to add this business activity?',
      () => {
        const args = {
          business_nature_id: _.get(data, 'business_nature_id'),
          business_line_id: _.get(data, 'business_line_id'),
          capital_amount: _.get(data, 'capital_amount').replace(/,/g, ''),
          gross_amount: _.get(data, 'gross_amount').replace(/,/g, ''),
          details: { ...details },
        };

        updateBusinessActivity(businessId, businessActivityId, args, () => {
          setViewUpdateForm(false);
          getBusinessActivityList(businessId);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  return (
    <div className="p-2">
      {viewForm === true && (
        <BusinessActivityCreateModal
          businessId={businessId}
          closeModal={closeModal}
          handleOnCreate={handleOnCreate}
        />
      )}
      {viewUpdateForm === true && (
        <BusinessActivityUpdateModal
          businessId={businessId}
          closeUpdateModal={closeUpdateModal}
          businessActivityInfo={formData}
          handleOnUpdate={handleOnUpdate}
        />
      )}
      <table className="transaction-table table table-sm border-0 custom-table my-1">
        <thead>
          <tr className="text-primary text-center">
            <th
              width="200"
              className="border-left border-top border-bottom py-3"
            >
              Line of Business
            </th>
            <th width="200" className="border-left border-top border-bottom">
              Philippine Standard Industrial Code
            </th>
            <th
              width="300"
              className="border-left border-top border-bottom py-3"
            >
              Details
            </th>
            <th
              width="250"
              className="border-left border-top border-bottom py-3"
            >
              {checkIfForRenewal ? 'Gross Amount' : 'Total Capitalization (Ph)'}
            </th>
            {type !== 'VIEW' && (
              <th
                width="250"
                className="border-left border-top border-bottom border-right"
              />
            )}
          </tr>
        </thead>
        <tbody>
          {type !== 'VIEW' &&
            businessActivityList.map(item => {
              return (
                <React.Fragment key={item.id}>
                  <tr>
                    <td>
                      <input
                        type="text"
                        readOnly
                        className="custom-input my-2"
                        value={_.get(item, 'attributes.name') || '-'}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        readOnly
                        className="custom-input my-2"
                        value={_.get(item, 'attributes.industrial_code') || '-'}
                      />
                    </td>
                    <td>
                      {_.get(item, 'attributes.details')
                        ? Object.entries(_.get(item, 'attributes.details')).map(
                            x => {
                              return (
                                <input
                                  key={`bpls_business_detail${x[0]}`}
                                  type="text"
                                  readOnly
                                  className="custom-input my-2 text-uppercase"
                                  value={`${ucwords(
                                    x[0].replace(/_/g, ' ') || null
                                  )}: ${x[1] || null}`}
                                />
                              );
                            }
                          ) || '-'
                        : ''}
                    </td>

                    <td>
                      <input
                        type="text"
                        readOnly
                        className="custom-input my-2"
                        value={
                          _.get(
                            item,
                            `attributes.${
                              checkIfForRenewal
                                ? 'gross_amount_human'
                                : 'capital_amount_human'
                            }`
                          ) || '-'
                        }
                      />
                    </td>
                    <td className="text-center">
                      <div className="d-flex justify-content-center align-items center my-2">
                        <button
                          onClick={handleUpdateBusinessActivity(
                            businessId,
                            item
                          )}
                          type="button"
                          className="btn-blank btn-sm"
                        >
                          <i className="far fa-edit icon-edit" />
                        </button>
                        <button
                          type="button"
                          className="btn-blank btn-sm"
                          onClick={handleRemoveBusinessActivity(
                            businessId,
                            item
                          )}
                        >
                          <i className="far fa-trash-alt icon-delete" />
                        </button>
                      </div>
                    </td>
                  </tr>
                </React.Fragment>
              );
            })}
          {type === 'VIEW' &&
            activityList.map((item, i) => {
              return (
                <tr key={`Item ${i + 1}`}>
                  <td>
                    <input
                      type="text"
                      readOnly
                      className="custom-input my-2"
                      value={_.get(item, 'attributes.name') || '-'}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      readOnly
                      className="custom-input my-2"
                      value={_.get(item, 'attributes.industrial_code') || '-'}
                    />
                  </td>
                  <td>
                    {_.get(item, 'attributes.details')
                      ? Object.entries(_.get(item, 'attributes.details')).map(
                          x => {
                            return (
                              <input
                                key={`bpls_business_detail${x[0]}`}
                                type="text"
                                readOnly
                                className="custom-input my-2 text-uppercase"
                                value={`${ucwords(
                                  x[0].replace(/_/g, ' ') || null
                                )}: ${x[1] || null}`}
                              />
                            );
                          }
                        ) || '-'
                      : ''}
                  </td>
                  <td>
                    <input
                      type="text"
                      readOnly
                      className="custom-input my-2"
                      value={_.get(item, 'attributes.capital_amount') || '-'}
                    />
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
      {type !== 'VIEW' && (
        <div>
          <button
            type="button"
            className="btn-primary cms-bg-color-primary cms-outline-primary  btn-md border-0 rounded text-sm py-2 px-4   "
            onClick={handleAddBusinessActivity}
          >
            <i className="fas fa-plus mr-1" />
            Add another
          </button>
        </div>
      )}
    </div>
  );
}

BusinessActivityList.defaultProps = {
  type: '',
  activityList: [],
};

BusinessActivityList.propTypes = {
  businessId: PropTypes.string.isRequired,
  getBusinessActivityList: PropTypes.instanceOf(Function).isRequired,
  businessActivityList: PropTypes.instanceOf(Array).isRequired,
  removeBusinessActivity: PropTypes.instanceOf(Function).isRequired,
  createBusinessActivity: PropTypes.instanceOf(Function).isRequired,
  updateBusinessActivity: PropTypes.instanceOf(Function).isRequired,
  type: PropTypes.string,
  activityList: PropTypes.instanceOf(Array),
  pathName: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }) => ({
  businessActivityList:
    _.get(api, `${c.GET_BUSINESS_ACTIVITY_LIST}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BusinessActivityList);
